export default "__VITE_ASSET__DmG0otJN__"